<script>export let isPrefix;
export let text;
</script>
<small class="pl_input__note {isPrefix?' pl_input__prefix':' pl_input__suffix'}">{text}</small>